export function salaryText() {
  const elements = [].slice.call(document.getElementsByClassName('js-salary-text'))
  if (elements.length === 0) return

  elements.forEach((el: HTMLElement) => {
    let text = el.innerHTML
    const regex = /[時給|日給|月給|～|〜|円]/g // 波ダッシュと全角チルダを指定
    text = text.replace(regex, '<span class="fc_black">$&</span>')
    el.innerHTML = text
  })
}
